module.exports = __webpack_public_path__ + "static/media/midwife.7c6ade0f.jpg";